/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ch_2_TInputs */

const en_cp_ch_2_t = /** @type {(inputs: Cp_Ch_2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product`)
};

const id_cp_ch_2_t = /** @type {(inputs: Cp_Ch_2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produk`)
};

/**
* | output |
* | --- |
* | "Product" |
*
* @param {Cp_Ch_2_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ch_2_t = /** @type {((inputs?: Cp_Ch_2_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ch_2_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ch_2_t(inputs)
	return en_cp_ch_2_t(inputs)
});